import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const steps = [
  {
    step: '01',
    title: 'Create your institution account',
    body: 'Set up your placement cell console in a minute. You become the admin for your institution — no engineering setup required.',
    icon: 'Building2',
  },
  {
    step: '02',
    title: 'Add or import students',
    body: 'Add students one by one or upload a CSV roster. Group them into placement batches by graduating year or drive.',
    icon: 'Users',
  },
  {
    step: '03',
    title: 'Allocate credits & design a campaign',
    body: 'Fund a credit pool for a batch, then design an interview once — role, type, difficulty and topics — and reuse it for everyone.',
    icon: 'Send',
  },
  {
    step: '04',
    title: 'Assign & track',
    body: 'Assign to your cohort and watch completion and scores roll in, using the same AI interviews and reports students already trust.',
    icon: 'BarChart3',
  },
];

const InstitutionHowItWorksSection = () => {
  return (
    <section id="how-it-works" className="border-t border-[var(--lp-line)] bg-white py-24 lg:py-28">
      <div className="mx-auto max-w-7xl px-5 sm:px-6 lg:px-8">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <p className="font-mono text-[11px] font-semibold tracking-[0.2em] text-[var(--lp-accent)]">
            How it works
          </p>
          <h2 className="mb-4 mt-4 text-3xl tracking-tight text-[var(--lp-ink)] sm:text-4xl lg:text-5xl">
            From roster to results in <span className="text-[var(--lp-accent)]">four steps.</span>
          </h2>
          <p className="text-lg leading-relaxed text-[var(--lp-ink-soft)]">
            Set up your console, load your students, and assign a mock interview to an entire batch — then follow along as scores come in.
          </p>
        </div>

        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {steps.map((item, i) => (
            <motion.div
              key={item.step}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              className="rounded-2xl border border-[var(--lp-line)] bg-white p-6"
            >
              <div className="mb-4 flex items-center gap-3">
                <span className="font-mono text-xs text-[var(--lp-accent)]">{item.step}</span>
                <Icon name={item.icon} size={18} className="text-[var(--lp-ink-soft)]" />
              </div>
              <h4 className="text-lg text-[var(--lp-ink)]">{item.title}</h4>
              <p className="mt-2 text-sm leading-relaxed text-[var(--lp-ink-soft)]">{item.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InstitutionHowItWorksSection;
